import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  Typography,
} from '@material-ui/core'

import Button from '@/components/button'

import { useStyles } from './styles'

interface BasicDialogProps extends DialogProps {
  title: string
  cancelMessage: string
  confirmMessage: string
  onConfirm: () => void
  onClose: () => void
}

export function BasicDialog({
  children,
  title,
  cancelMessage,
  confirmMessage,
  onConfirm,
  ...props
}: BasicDialogProps) {
  const classes = useStyles()

  return (
    <Dialog className={classes.main} {...props}>
      <DialogTitle disableTypography>
        <Typography variant='h1'>{title}</Typography>
      </DialogTitle>

      <DialogContent>
        <Typography>{children}</Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={props.onClose} labelOnly>
          {cancelMessage}
        </Button>
        <Button onClick={onConfirm} labelOnly autoFocus>
          {confirmMessage}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
